<template>
  <div class="docendo-connection-indicator">
    <div id="connection_lost" v-show="!is_connected" style="display: none;">Genopretter forbindelse...</div>
  </div>
</template>

<script>
  import docendo from '../docendo'

  export default {
    name: 'DocendoConnnectionIndicator',
    created: function () {
      docendo.subscribeConnected(this.connected)
      docendo.subscribeDisconnected(this.disconnected)
    },
    methods: {
      connected: function () {
        this.is_connected = true
      },
      disconnected: function () {
        this.is_connected = false
      }
    },
    data () {
      return {
        is_connected: true
      }
    }
  }
</script>

<style scoped>
  @import ".././assets/css/variables.css";

  #connection_lost {
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: white;
    background-color: var(--dark-blue);
  }
</style>



// WEBPACK FOOTER //
// DocendoConnectionIndicator.vue?e0449dfe